import Loading from "../Loading";
import css from "./index.module.css";
import HexagonIcon from '@mui/icons-material/Hexagon';

/**
 * prequisites (missions) that are required to start a challenge
 * @param {Object} challenge data for the given challenge
 * @param {Array} challengePrerequisites list of missions that are required for the given challenge
 * @param {Array} completedPrerequisites list of missions that were already completed by given student
 * @param {Array} missions list of missions
 * @returns 
 */
const Prerequisites = ({ challenge, challengePrerequisites, completedPrerequisites, missions }) => {
  if(missions == null) {
    return <Loading />;
  } else if (missions != null && missions.length === 0) {
    return <span>data not loaded</span>;
  } else if (missions != null && missions.length > 0) {
    return (
      <div className={css.list}>
        <div className={css.header}>
          <span>Vorrausgesetzte Missionen</span>
        </div>
        <div className={css.body}>
          {challengePrerequisites?.filter((e) => e.challenge_id === challenge.id)
            .map((element, i) => {
              let mission = missions.find(e => e.id === element.mission_id);
              let completed = false;
              completedPrerequisites?.forEach((join) => {
                if (join.challenge_id === challenge.id && element.mission_id === join.mission_id) {
                  completed = true;
                }
              });
              return (
                
                <div key={"prequisite_" + element.challenge_id + i} className={completed ? css.completed : css.uncompleted}>
                  <span>Mission {mission?.name}</span>
                  <HexagonIcon />
                </div>
                
              );
          })}
        </div>
      </div>
    )
  }

};

export default Prerequisites;
